import { CircularProgress, Grid } from '@mui/material'
import Water_Merlin from '../../../assets/devices/WaterMerlinNBOT.svg'
import Q600 from '../../../assets/devices/Q600.svg'
import NXS from '../../../assets/devices/NXCM_AC250.svg'
import Eletric from '../../../assets/devices/A4R.svg'
import { type AssetByIdState } from '../redux/assetByIdSlice'
import DeviceUtil from '../../../utils/DeviceUtil'
import DefaultImage from '../../../assets/devices/No-Image-Placeholder.svg'
import HBG3 from '../../../assets/devices/HBG3.svg'
import editIconWhite from '../../../assets/editIconWhite.svg'
import editIcon64C3FF from '../../../assets/editIcon64c3ff.svg'
import React from 'react'
import LanguageStrings from '../../../i18n/locales'
import AuthError from '../../../components/ErrorComponents/AuthError'
import errorCrossIcon from '../../../assets/errorCrossIcon.svg'
import tickButton from '../../../assets/tickButton.svg'
import { isValidIp, isValidPort } from '../../../utils/validator'
import { type RootState } from '../../../store'
import { type ConnectedProps, connect, useSelector } from 'react-redux'
import { fetchAssetData, postIpConfig } from '../redux/actionCreator'
import { type IPConfigRequest } from '../services/postIPConfigService'
import { type IPConfigState } from '../redux/ipConfigSlice'
import { getOperationPermissions } from '../../dashboard/redux/actionCreator'
import { type OperationPermissionState } from '../../dashboard/redux/operationPermissionSlice'
import { useAuth } from 'react-oidc-context'

const assetValuesStyles = {
  color: '#F0F0F0',
  fontWeight: '500'
}

const ParameterListComponentStrings = LanguageStrings().AssetConfigurationStrings.components.AssetDetailsComponents.ParameterListComponent

function getDeviceImage (device: any): string {
  if (device != null) {
    if (DeviceUtil.getDeviceTypeByName(device)?.isGas === true) {
      return NXS
    } else if (DeviceUtil.getDeviceTypeByName(device)?.isElectric === true) {
      return Eletric
    } else if (DeviceUtil.getDeviceTypeByName(device)?.isWater === true) {
      if (DeviceUtil.getDeviceTypeByName(device)?.isQ600 === true) {
        return Q600
      } else if (DeviceUtil.getDeviceTypeByName(device)?.isHBG3 === true) {
        return HBG3
      }
      return Water_Merlin
    }
  }
  return DefaultImage
}

const AssetSummary = (props: AllProps): JSX.Element => {
  const initialIpaddr = props.assetData.assetData?.ip_address === null ? '' : props.assetData.assetData?.ip_address
  const initialPort = props.assetData.assetData?.port === null ? '' : props.assetData.assetData?.port
  const operationPermissions: OperationPermissionState = useSelector((state: RootState) => state.operationPermissions)
  const [tickColor, setTickColor] = React.useState('#404040')
  const [editIcon, setEditIcon] = React.useState(editIconWhite)
  const [editEnabled, setEditEnabled] = React.useState(false)
  const [ip, setIp] = React.useState(initialIpaddr === undefined ? '' : initialIpaddr)
  const [port, setPort] = React.useState(initialPort === undefined ? '' : initialPort)
  const [ipError, setIpError] = React.useState('')
  const [portError, setPortError] = React.useState('')
  const auth = useAuth()

  const toggleEditIcon = (): void => {
    if (editIcon === editIconWhite) setEditIcon(editIcon64C3FF)
    else setEditIcon(editIconWhite)
  }

  React.useEffect(() => {
    if (!operationPermissions.updated) {
      props.getOperationPermissions(auth.user?.profile.sub as string)
    }
  }, [])

  const renderIpAndPort = (): string => {
    if (props.assetData.assetData?.ip_address === null && props.assetData.assetData?.port !== null) {
      return props.assetData.assetData?.port
    } else if (props.assetData.assetData?.ip_address !== null && props.assetData.assetData?.port === null) {
      return props.assetData.assetData?.ip_address
    } else if (props.assetData.assetData?.ip_address !== null && props.assetData.assetData?.port !== null) {
      return `${props.assetData.assetData?.ip_address !== undefined ? props.assetData.assetData?.ip_address : ''} : ${props.assetData.assetData?.port !== undefined ? props.assetData.assetData?.port : ''}`
    }
    return 'Not Available'
  }

  const toggleTickColor = (): void => {
    if (tickColor === '#404040') setTickColor('#64C3FF')
    else setTickColor('#404040')
  }

  const handleIpChange = (e: any): void => {
    if (e.target.value === '') {
      setIpError('')
      setIp('')
    } else if (!isValidIp(e.target.value)) {
      setIpError('Invalid IP')
      setIp(e.target.value)
    } else {
      setIpError('')
      setIp(e.target.value)
    }
  }

  const handlePortChange = (e: any): void => {
    if (e.target.value === '') {
      setPortError('')
      setPort('')
    } else if (!isValidPort(e.target.value)) {
      setPortError('Invalid Port')
      setPort(e.target.value)
    } else {
      setPortError('')
      setPort(e.target.value)
    }
  }

  const handlePostIpConfigWithFailure = (): JSX.Element => {
    if (props.ipConfigState.isLoading) {
      return (
        <span><CircularProgress /></span>
      )
    } else {
      return <></>
    }
  }

  const handleIpConfigPost = (): void => {
    if (ipError === '' && portError === '' && (ip !== initialIpaddr || port !== initialPort)) {
      props.postIpConfig(props.assetData.assetData?.id === undefined ? '' : props.assetData.assetData?.id, { ip_address: ip !== '' ? ip : null, port: port !== '' ? port : null })
    }
  }

  if (props.assetData.httpStatus === 401) {
    return (
      <div className="authError">
        <AuthError errorMessage="Unauthorized" />
      </div>
    )
  } else if (props.assetData.httpStatus === 403) {
    return (
      <div className="authError">
        <AuthError errorMessage="accessForbidden" />
      </div>
    )
  } else {
    return (
    <Grid container style={{ paddingTop: '20px' }}>
      <Grid xs={12} sm={2}>
        <div
          style={{
            padding: '10px',
            backgroundColor: 'white',
            height: 'fit-content',
            borderRadius: '10px',
            width: 'fit-content'
          }}
        >
          <img
            src={
              getDeviceImage(props.assetData.assetData?.device_type)
            }
            style={{ width: '100px', height: 'auto' }}
          />
        </div>
      </Grid>
      <Grid container xs={12} sm={10}>
        <Grid container className='assetSummaryRow'>
          <Grid item xs={12} sm={3}>
            <Grid>{props.OverviewStrings.Asset_Type}</Grid>
            <Grid style={{ color: '#64C3FF' }}>
              {props.assetData.assetData?.device_type}
            </Grid>
          </Grid>
          <Grid item xs={12} sm={3}>
            <Grid>{props.OverviewStrings.State}</Grid>
            <Grid style={assetValuesStyles}>{props.assetData.assetData?.asset_state}</Grid>
          </Grid>
          <Grid item xs={12} sm={3}>
            <Grid>{props.OverviewStrings.Year_of_Certification}</Grid>
            <Grid>-----</Grid>
          </Grid>
        </Grid>
        <Grid container className='assetSummaryRow'>
          <Grid item xs={12} sm={3}>
            <Grid>{props.OverviewStrings.Asset_Configuration}</Grid>
            <Grid style={{ color: '#64C3FF' }}>-----</Grid>
          </Grid>
          <Grid item xs={12} sm={3}>
            <Grid>{props.OverviewStrings.Serial_Number}</Grid>
            <Grid style={assetValuesStyles}>{props.assetData.assetData?.comm_mod_serial ?? ParameterListComponentStrings.Not_Applicable}</Grid>
          </Grid>
          <Grid item xs={12} sm={3}>
            <Grid>{props.OverviewStrings.Installation_Date}</Grid>
            <Grid>
              {props.assetData.assetData?.install_date !== null &&
              props.assetData.assetData?.install_date !== undefined
                ? new Date(
                  props.assetData.assetData?.install_date
                ).toDateString()
                : '----'}
            </Grid>
          </Grid>
        </Grid>
        <Grid container className='assetSummaryRow'>
        <Grid item xs={12} sm={3}>
            <Grid>Meter Serial Number</Grid>
            <Grid>
              {props.assetData.assetData?.serial_number}
            </Grid>
        </Grid>
        {((props.assetData.assetData?.device_type.startsWith('Water')) === true) && (
          <>
              <Grid item xs={12} sm={3}>
                  <Grid>Meter Date of Expiry</Grid>
                  <Grid>
                    -----
                  </Grid>
                </Grid>
                <Grid item xs={12} sm={3}>
                  <Grid>Remaining Battery Percentage</Grid>
                  <Grid>
                  {((props.assetData.assetData?.rem_bat_percent) != null) ? props.assetData.assetData?.rem_bat_percent?.toString() : 'Not Available'}
                  </Grid>
                </Grid>
          </>
        )}
        </Grid>
        {((props.assetData.assetData?.device_type.startsWith('Water')) === true) && (
        <Grid container className='assetSummaryRow'>
          <Grid item xs={12} sm={3}>
            <Grid>Meter Date of Shipment</Grid>
            <Grid>
              -----
            </Grid>
          </Grid>
          <Grid item xs={12} sm={3}>
            <Grid>Firmware Version</Grid>
            <Grid>
              -----
            </Grid>
          </Grid>
          <Grid item xs={12} sm={4}>
            <Grid>IP & Port {operationPermissions.permissions.can_modify_asset ? <img data-testid='edit-btn' width={16} style={{ cursor: 'pointer' }} onClick={() => { setEditEnabled(!editEnabled) }} onMouseOver={toggleEditIcon} onMouseOut={toggleEditIcon} src={editIcon} alt='edit-icon' /> : <></>}</Grid>
            {
              (!editEnabled)
                ? <Grid>
                    {renderIpAndPort()}
                  </Grid>
                : <Grid>
                  <div style={{ display: 'flex', paddingTop: '10px', alignItems: 'center' }}>
                  <span style={{ display: 'flex', flexDirection: 'column', position: 'relative' }}>
                    <input type='text' className='ipandporttextbox' onChange={handleIpChange} style={{
                      backgroundColor: '#404040', border: 'none', color: '#F0F0F0', fontSize: '16px', marginRight: 10, width: '170px', padding: '7px'
                    }} value={ip} data-testid='ip' placeholder='IP Address' />
                    <span style={{ color: '#FF6F67', marginTop: ipError !== '' ? '10px' : 0, position: 'absolute', top: '34px', fontSize: '14px' }}>{ipError !== '' ? <img src={errorCrossIcon} /> : <></>} {ipError}</span>
                  </span>
                  <span style={{ display: 'flex', flexDirection: 'column', position: 'relative' }}>
                    <input type='text' className='ipandporttextbox' onChange={handlePortChange} style={{
                      backgroundColor: '#404040', border: 'none', color: '#F0F0F0', fontSize: '16px', width: '100px', padding: '7px'
                    }} value={port} data-testid='port' placeholder='Port' />
                    <span style={{ color: '#FF6F67', marginTop: portError !== '' ? '10px' : 0, position: 'absolute', top: '34px', fontSize: '14px' }}>{portError !== '' ? <img src={errorCrossIcon} /> : <></>} {portError}</span>
                  </span>
                  <span onClick={handleIpConfigPost} onMouseOver={toggleTickColor} onMouseOut={toggleTickColor} style={{ backgroundColor: tickColor, padding: '4.5px', borderRadius: '4px', marginLeft: 10, display: 'flex', alignItems: 'center', cursor: 'pointer' }}><img src={tickButton} /></span>
                </div>
                {handlePostIpConfigWithFailure()}
                </Grid>
            }
          </Grid>
        </Grid>
        )}
        <Grid
          style={{
            marginTop: '20px',
            marginBottom: '20px',
            paddingTop: '20px',
            paddingBottom: '20px'
          }}
          container
        >
        </Grid>
      </Grid>
    </Grid>
    )
  }
}

interface DispatchToProps {
  postIpConfig: (assetId: string, ipConfigRequest: IPConfigRequest) => void
  fetchAssetData: (id: string, tenantId: string) => void
  getOperationPermissions: (sub: string) => void
}

const mapDispatchToProps = (dispatch: any): DispatchToProps => ({
  postIpConfig: (id: string, ipConfigRequest: IPConfigRequest) => dispatch(postIpConfig(id, ipConfigRequest)),
  fetchAssetData: (id: string, tenantId: string) => dispatch(fetchAssetData(id, tenantId)),
  getOperationPermissions: (sub: string) => dispatch(getOperationPermissions(sub))
})

interface StateToProps {
  ipConfigState: IPConfigState
  assetId: string
}

const mapStateToProps = (state: RootState): StateToProps => ({
  ipConfigState: state.ipConfigState,
  assetId: state.assetId
})

const connector = connect(mapStateToProps, mapDispatchToProps)
type PropsFromRedux = ConnectedProps<typeof connector>

interface ParentProps {
  assetData: AssetByIdState
  OverviewStrings: any
}

type AllProps = PropsFromRedux & ParentProps

export default connector(AssetSummary)
